import { useContext } from '@fipnooone/react-modal';
import { useState } from 'react';

import { Api, Code } from '@.api';
import { useForm } from '@.hooks';

import { EditLicenseKeyHttpFormState } from './EditLicenseKeyHttpFormState';
import { EditLicenseKeyHttpValidateOptions } from './EditLicenseKeyHttpValidateOptions';

type UseDeviceCardParams = {
    deviceId: number;
    licenseKeyInitial: string;
    updateDevice: (deviceId: number, licenseKey: string) => void;
};

export const useEditLicenseKeyHttp = ({ updateDevice, licenseKeyInitial, deviceId }: UseDeviceCardParams) => {
    const [isLoading, setLoading] = useState<boolean>(false);

    const [field, form] = useForm<EditLicenseKeyHttpFormState>({
        licenseKey: licenseKeyInitial || '',
        isForcedPending: false,
    });

    const { close } = useContext();

    const requestSaveLicenseKey = () => {
        form.ifValid((data) => {
            setLoading(true);

            Api.devices()
                .updateLicenseKey(deviceId, data.licenseKey, data.isForcedPending)
                .onSuccess((response) => {
                    if (response.code === Code.Success) {
                        if (response.data.license_key) {
                            updateDevice(deviceId, response.data.license_key || '');
                        } else {
                            console.error('license key not found');
                        }
                    }

                    close();
                })
                .onValidationError((response) => {
                    form.set.fieldError('licenseKey', [response.message]);
                })
                .then(() => setLoading(false));
        }, EditLicenseKeyHttpValidateOptions);
    };

    return {
        isLoading,
        field,
        close,
        requestSaveLicenseKey,
    };
};
